<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="姓名:" prop="sailorName">
              <el-input  placeholder="" v-model="searchFrom.sailorName"></el-input>
            </el-form-item>
             <el-form-item label="身份证号:" prop="identityCard">
              <el-input  placeholder="" v-model="searchFrom.identityCard"></el-input>
            </el-form-item>
             <el-form-item label="手机:" prop="phone">
              <el-input  placeholder="" v-model="searchFrom.phone"></el-input>
            </el-form-item>
             <el-form-item label="职务:" prop="dutiesId">
                <el-select  v-model="searchFrom.dutiesId"   placeholder="请选择">
                  <el-option v-for="item in ZWList" :label="item.showName" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
        <div style="display: flex;justify-content: space-between; align-items: center;">
          <div class="searchBtnBox" >
            <el-form-item v-if="btnFlg[0]" >
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item  v-if="btnFlg[1]">
                <el-button type="primary"  @click="addRegion">新增</el-button>
              </el-form-item>
              <el-form-item  v-if="btnFlg[2]" >
                <el-button type="primary"  @click="delFn">删除</el-button>
              </el-form-item>
              <el-form-item v-if="btnFlg[3]">
                <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
              </el-form-item>
          </div>
          <div class="biaoshiBox">
            <div style="margin-right:20px">
                <i class="fa fa-square" aria-hidden="true"></i>
                <span>即将到期</span>
            </div>
            <div>
                <i class="fa fa-square" style="color:red" aria-hidden="true"></i>
                <span>已经超期</span>
            </div>
          </div>
        </div>

      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border :cell-class-name="tablecellClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"  v-if="btnFlg[4]"    @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini"  v-if="btnFlg[5]"   @click="jianliFN(scope.row)">简历</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="sailorName" min-width="120"  :formatter="emptyFn" label="姓名"></el-table-column>
       <el-table-column prop="dutiesName" min-width="120"  :formatter="emptyFn" label="职务"></el-table-column>
         <el-table-column property="practiceFlag" width="120" label="实习标识" >
          <template scope="scope">
            {{[ "是", "否" ][scope.row.practiceFlag-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="identityCard" width="170"  label="身份证号码(服务薄)"></el-table-column>
        <el-table-column prop="bornAddress"  min-width="200" :formatter="emptyFn" label="出生地"></el-table-column>
        <el-table-column prop="aboardAddress" width="120" :formatter="emptyFn" label="上船地点"></el-table-column>
        <el-table-column prop="aboardTime" width="170" :formatter="dateFormat"  label="上船时间"></el-table-column>
        <el-table-column prop="disembarkAddress" width="120" :formatter="emptyFn" label="下船地点"></el-table-column>
        <el-table-column prop="disembarkTime" width="170" :formatter="dateFormat"  label="下船时间"></el-table-column>
        <el-table-column prop="phone" width="300" :formatter="emptyFn" label="联系电话"></el-table-column>
        <el-table-column prop="workLicenseTime" width="170" :formatter="dateFormat"  label="适任证有效期"></el-table-column>
        <el-table-column prop="healthLicenseTime" width="170" :formatter="dateFormat"  label="健康证有效期"></el-table-column>
        <el-table-column prop="contractTerm" width="150" :formatter="emptyFn" label="合同期"></el-table-column>
        <el-table-column prop="pay" width="150" :formatter="emptyFn" label="工资(元)"></el-table-column>
        <el-table-column prop="familyTel" width="150" :formatter="emptyFn" label="家庭电话"></el-table-column>
        <el-table-column prop="familyContactsName" width="150" :formatter="emptyFn" label="家庭联系人"></el-table-column>
        <el-table-column prop="remark" :show-overflow-tooltip="true"  min-width="200" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="1000px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
          </div>
              <el-form-item label="姓名:" prop="sailorName" >
                <el-input  placeholder=""    maxlength="32" v-model="addFrom.sailorName"  ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityCard">
                <el-input  placeholder="" maxlength="18" v-number-input.float="0"    v-model="addFrom.identityCard"></el-input>
              </el-form-item>
              <el-form-item label="出生地:" prop="bornAddress">
                <el-input  placeholder=""    maxlength="32" v-model="addFrom.bornAddress"  ></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="phone">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0"    v-model="addFrom.phone"></el-input>
              </el-form-item>
              <el-form-item label="家庭电话:" prop="familyTel">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0"    v-model="addFrom.familyTel"></el-input>
              </el-form-item>
              <el-form-item label="家庭联系人:" prop="familyContactsName">
                <el-input  placeholder="" maxlength="32"   v-model="addFrom.familyContactsName"></el-input>
              </el-form-item>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>任职相关</span>
              </h4>
            </div>
              <el-form-item label="职务:" prop="duties">
                <el-select  v-model="addFrom.duties"  value-key="id"  placeholder="请选择" filterable>
                  <el-option v-for="(item,index) in ZWList" :label="item.showName" :value="item" :key="index"></el-option>
                 </el-select>
              </el-form-item>
              <el-form-item label="实习标志:" prop="practiceFlag" class="ziti" >
                <div style="width:150px">
                   <el-radio-group v-model="addFrom.practiceFlag" >
                      <el-radio :label="2">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item label="上船地点:" prop="aboardAddress">
              <el-input  placeholder="" maxlength="32"   v-model="addFrom.aboardAddress"></el-input>
            </el-form-item>
            <el-form-item label="上船时间:" prop="aboardTime" >
                <el-date-picker  v-model="addFrom.aboardTime"  format="yyyy-MM-dd" value-format="timestamp" type="date"
                placeholder="选择日期时间" ></el-date-picker>
            </el-form-item>
            <el-form-item label="下船地点:" prop="disembarkAddress">
              <el-input  placeholder="" maxlength="32"   v-model="addFrom.disembarkAddress"></el-input>
            </el-form-item>
            <el-form-item label="下船时间:" prop="disembarkTime" >
              <el-date-picker  v-model="addFrom.disembarkTime"  format="yyyy-MM-dd" value-format="timestamp" type="date"
              placeholder="选择日期时间" ></el-date-picker>
            </el-form-item>
            <el-form-item label="适任证有效期:" prop="workLicenseTime" >
              <el-date-picker  v-model="addFrom.workLicenseTime"  format="yyyy-MM-dd" value-format="timestamp" type="date"
              placeholder="选择日期时间" ></el-date-picker>
            </el-form-item>
            <el-form-item label="健康证有效期:" prop="healthLicenseTime" >
              <el-date-picker  v-model="addFrom.healthLicenseTime"  format="yyyy-MM-dd" value-format="timestamp" type="date"
              placeholder="选择日期时间" ></el-date-picker>
            </el-form-item>
            <el-form-item label="合同期:" prop="contractTerm">
              <el-input  placeholder=""  maxlength="32"   v-model="addFrom.contractTerm"></el-input>
            </el-form-item>
            <el-form-item label="工资:" prop="pay" class="jiage">
              <el-input  placeholder="" maxlength="6" v-number-input.float="0"   v-model="addFrom.pay"></el-input>
              <span class="danwei">元</span>
            </el-form-item>
            <el-form-item label="备注:" class="remark" prop="remark" >
              <el-input  placeholder="" type="textarea" rows="1"  maxlength="20" v-model="addFrom.remark"></el-input>
            </el-form-item>
          <hr>
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>上传简历</span>
              </h4>
            </div>
          <div style="width:400px">
            <el-upload
              action=""
              :auto-upload=false
              :multiple=true
              :file-list="filelist"
              :on-change="imgPreview"
              accept=".xls,.xlsx,.doc,.pdf"
              :limit="1"
              :on-remove="handleRemove" :class="[fileIsAdd?'hidden':'']">
              <i class="el-icon-upload"></i>
            </el-upload>
          </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sShipSailorInfoList, sShipSailorInfoAdd, sShipSailorInfoDelete, sShipDictionaryList, sShipSailorInfoUpdate } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dialogVisible: false,
      isAdd: true,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        sailorName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        identityCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        bornAddress: [
          { required: true, message: '请输入出生地', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        familyTel: [
          this.rule.mobile
        ],
        duties: [
          { required: true, message: '请选择职务', trigger: 'blur' }
        ],
        practiceFlag: [
          { required: true, message: '请选择实习标识', trigger: 'blur' }
        ],
        aboardAddress: [
          { required: true, message: '请输入上船地址', trigger: 'blur' }
        ],
        aboardTime: [
          { required: true, message: '请选择上船时间', trigger: 'blur' }
        ],
        disembarkAddress: [
          { required: true, message: '请输入下船地址', trigger: 'blur' }
        ],
        disembarkTime: [
          { required: true, message: '请选择下船时间', trigger: 'blur' }
        ],
        workLicenseTime: [
          { required: true, message: '请选择适任证有效期', trigger: 'blur' }
        ],
        healthLicenseTime: [
          { required: true, message: '请选择健康证有效期', trigger: 'blur' }
        ],
        contractTerm: [
          { required: true, message: '请输入合同期', trigger: 'blur' }
        ]
      },
      addFrom: {
      },
      ZWList: [], // 职务
      productTypes: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      filelist: [],
      fileIsAdd: false,
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00KM090100', '00KM090200', '00KM090300', '00KM090400', '00KM090500', '00KM090600']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    sShipDictionaryList({ groupNo: 'ship_duties' }).then(res => {
      this.ZWList = res
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 简历
    jianliFN (row) {
      if (row.fileUrlOSS) {
        var tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.fileUrlOSS// 后更改页面地址
      } else {
        this.$alert('暂未上传简历', '系统提示')
      }
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.shipping + '/sShipSailorInfo/exportSShipSailorInfo',
        form,
        '船员列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 文件上传
    handleRemove (file, fileList) {
      this.filelist = fileList
      if (fileList.length < 1) {
        this.fileIsAdd = false
      }
      if (this.addFrom.fileUrl) {
        this.addFrom.fileUrl = ''
      }
    },
    imgPreview (file, fileList) {
      this.filelist = fileList
      if (fileList.length == 1) {
        this.fileIsAdd = true
      } else {
        this.fileIsAdd = false
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sShipSailorInfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.dialogVisible = true
      this.isAdd = true
    },
    editFn (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (this.addFrom.dutiesId) {
        this.$set(this.addFrom, 'duties', { showName: row.dutiesName, id: row.dutiesId })
      }
      if (row.fileUrlOSS) {
        this.$set(this.filelist, 0, { status: 'ready', name: row.fileUrl.substring(row.fileUrl.lastIndexOf('/') + 1), url: row.fileUrlOSS, flag: true })
        this.fileIsAdd = true
      } else {
        this.filelist = []
        this.fileIsAdd = false
      }
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (this.addFrom.duties) {
            this.addFrom.dutiesId = this.addFrom.duties.id
            this.addFrom.dutiesName = this.addFrom.duties.showName
          }
          let formData = new FormData()
          if (this.filelist.length == 1 && !this.filelist[0].flag) {
            formData.append('file', this.filelist[0].raw)
          }
          formData.set('params', JSON.stringify(this.addFrom))
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipSailorInfoAdd(formData).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipSailorInfoUpdate(formData).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let ids = []
      selectData.forEach(item => {
        ids.push(item.id)
      })
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipSailorInfoDelete({ ids: ids }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = { }
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.filelist = []
      this.fileIsAdd = false
    },
    // 适任证有效期/健康证有效期格式化
    tablecellClassName ({ row, column }) {
      let nowdate = new Date().getTime()
      if (column.property == 'workLicenseTime') {
        if (row.workLicenseTime <= nowdate) {
          return 'color1'
        }
        if (row.workLicenseTime < nowdate + 30 * 8.64e7) {
          return 'color2'
        }
      }
      if (column.property == 'healthLicenseTime') {
        if (row.healthLicenseTime <= nowdate) {
          return 'color1'
        }
        if (row.healthLicenseTime < nowdate + 30 * 8.64e7) {
          return 'color2'
        }
      }
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/ .inpBox .el-date-editor .el-input__inner {
    width: 150px;
}
.jiage{
  position: relative;
  .danwei1{
    position: absolute;
    right: 6px;
  }
}
.iconBox {
  position: absolute;
  right: -28px;
  top: 0;
  font-size: 20px;
  color: #0b25d6;
  z-index: 9999;
}
/deep/.el-textarea{
      width: 442px;
}
/deep/.el-upload--text{
   width: 100px;
    height: 100px;
    border: 1px #ddd solid;
}
/deep/.el-upload--text i{
    font-size: 50px;
    margin-top: 25px;
}
.hidden /deep/.el-upload--text{
  display: none;
}
/deep/.color1{
  background: red;
}
/deep/.color2{
  background: rgb(255, 255, 0);
}
.biaoshiBox{
  display: flex;
  font-size: 14px;
}
.fa-square{
  margin-right: 8px;
  font-size: 18px;
  color: rgb(255, 255, 0);
}
</style>
